import { useEffect, useState } from 'react';
import { ButtonMedia } from '@/components/atoms';
import { MediaSelectModal } from '@/components/templates';
import Portal from '@/components/common/Portal';
import { useFirstIncome, useCommonParams, useOrganicUser } from '@/hooks';
import styled from 'styled-components';
import { rem } from '@/styles/theme';

const Container = styled.div`
  position: fixed;
  width: 100%;
  max-width: ${rem(414)};
  z-index: 300;
  top: 0;
  background: ${({ theme }) => theme.color.white};
`;

const Wrapper = styled.div`
  padding: ${rem(16)} ${rem(18)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: ${rem(52)};
`;
const ImageWrapper = styled.div`
  height: ${rem(20)};
`;
const NoticeWrapper = styled.div`
  background: #6250ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
`;
const NoticeCenterWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const NoticeText = styled.div`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  font-style: normal;
  font-weight: 500;
  color: ${({ theme }) => theme.color.white};
  text-align: center;
`;

const Image = styled.img``;

const WebViewHeader = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const [isOrganicUser] = useOrganicUser();
  const [firstIncome, setFirstIncome] = useFirstIncome();
  const { media } = useCommonParams();
  const isNotLGU = media !== 'lgu';

  const handleTelecomChange = () => {
    setModalOpen(true);
  };

  const handleClickClose = () => {
    setFirstIncome(false);
    localStorage.setItem('firstIncome', 'come');
  };

  useEffect(() => {}, [media]);

  return (
    <Container>
      {firstIncome && isOrganicUser && isNotLGU ? (
        <NoticeWrapper>
          <Image src="/close.svg" alt="close" onClick={handleClickClose} loading="lazy" />
          <NoticeCenterWrap onClick={handleTelecomChange}>
            <NoticeText>{media.toUpperCase()} 이용 중이신가요? 특별혜택을 받아 가세요!</NoticeText>
          </NoticeCenterWrap>
        </NoticeWrapper>
      ) : (
        <></>
      )}
      <Wrapper>
        <ImageWrapper>
          <Image src={`/pass_${media}.svg`} alt="media" loading="lazy" />
        </ImageWrapper>
        {isOrganicUser && isNotLGU && (
          <ButtonMedia onClick={handleTelecomChange} size={'xs'}>
            통신사 변경
          </ButtonMedia>
        )}
      </Wrapper>
      <Portal>
        <MediaSelectModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      </Portal>
    </Container>
  );
};

export default WebViewHeader;
